import { render, staticRenderFns } from "./examDetails.vue?vue&type=template&id=4543a35d&scoped=true"
import script from "./examDetails.vue?vue&type=script&lang=js"
export * from "./examDetails.vue?vue&type=script&lang=js"
import style0 from "./examDetails.vue?vue&type=style&index=0&id=4543a35d&prod&lang=stylus&scoped=true"
import style1 from "./examDetails.vue?vue&type=style&index=1&id=4543a35d&prod&lang=stylus&scoped=true"
import style2 from "./examDetails.vue?vue&type=style&index=2&id=4543a35d&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4543a35d",
  null
  
)

export default component.exports